/////////////////////////////////////////////
// 無料お試し期間関連定数

import { addMonthLimitLastDays, calcLastDate } from "./date_util";

/////////////////////////////////////////////
export const TRIAL_PERIOD_MONTH = 1;   // 無料お試し期間（ヶ月）

/////////////////////////////////////////////
// 無料お試し期間ユーティリティ
/////////////////////////////////////////////

/**
 * 無料お試し期間終了日の算出。
 * @param start_date 登録開始日。
 * @param add_date お試し期間終了日に加算する日数。
 * @returns お試し期間終了日 + add_date
 */
export function calcTrialEndDate( start_date: Date, add_date: number){
  // x月1日の場合はx月末日まで。それ以外は翌月末までとする。（TRIAL_PERIOD_MONTHが1の場合）
  let end_date = new Date( start_date );  // copy
  end_date = addMonthLimitLastDays( end_date, TRIAL_PERIOD_MONTH ); // TRIAL_PERIOD_MONTH ヶ月加算。
  end_date.setDate( end_date.getDate() - 1 ); // x月1日にTヶ月加算すると、x+T月1日になってしまうので、-1日して、末日までとする。

  // 末日にする。
  end_date = calcLastDate( end_date );

  // 日付加算
  end_date.setDate(end_date.getDate() + add_date);

  return end_date;
}

/**
 * 無料お試し期間終了日文字列の作成。
 * @param start_date_str 開始日文字列
 * @returns 
 */
export function makeTrialEndDateStr( start_date_str: string){
  const start_date = new Date(start_date_str);
  const end_date = calcTrialEndDate( start_date, 0 );
  
  // 文字列化
  return "" + (end_date.getMonth()+1) + "/" + end_date.getDate();
}
